import React from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

const styles = {
  locationInputRoot: {
    position: "relative",
  },
  autoCompleteDropDownContainer: {
    position: "absolute",
    top: "40px",
    background: "white",
    borderLeft: "1px solid #ccc",
    borderRight: "1px solid #ccc",
    width: "100%",
    zIndex: "1000",
  },
};

export default ({ formik, name, className, disabled, onChange, startIcon }) => {
  const classes = styles;

  const handleChange = (address) => {
    console.log("address", address);
  };

  const handleSelect = async (address) => {
    let geoCoordinates = null;

    formik.setFieldValue(name, address);

    try {
      const results = await geocodeByAddress(address);
      geoCoordinates = await getLatLng(results[0]);
    } catch (e) {
    } finally {
      if (onChange) {
        onChange({
          address,
          geoCoordinates,
        });
      }
    }
  };

  return (
    <PlacesAutocomplete
      onChange={handleChange}
      onSelect={handleSelect}
      {...formik.getFieldProps(name)}
    >
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div style={classes.locationInputRoot}>
          {startIcon && startIcon}
          <input
            label="Location"
            variant="outlined"
            {...getInputProps({
              placeholder: "Search Places ...",
              className: className,
            })}
            onChange={(event) => {
              getInputProps({
                placeholder: "Search Places ...",
                className: className,
              }).onChange(event);

              formik.setFieldValue(name, event.target.value);
            }}
            disabled={disabled}
          />
          <div style={classes.autoCompleteDropDownContainer}>
            {loading && <div key={"loading-key"}>Loading...</div>}
            {suggestions.map((suggestion) => {
              const style = suggestion.active
                ? { backgroundColor: "#fafafa", cursor: "pointer" }
                : { backgroundColor: "#ffffff", cursor: "pointer" };

              return (
                <div
                  {...getSuggestionItemProps(suggestion, {
                    className: "dropDownFiedContainer",
                    style,
                  })}
                  key={suggestion.placeId}
                >
                  <span>{suggestion.description}</span>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  );
};
